import React from 'react'
import { TStatsHead } from './styles'
import { TeamGQL } from '../../../../Api'
import { StatRow } from './StatRow'
import { teamStatCompareList } from '../../../../Utils/Teams/teamHelpers'
type TeamStatsProps = {
  year: number
  homeTeam: TeamGQL | null
  awayTeam: TeamGQL | null
  seasonSegment?: string
}

export const TeamStatsComparison: React.FC<React.PropsWithChildren<TeamStatsProps>> = ({
  year,
  seasonSegment,
  homeTeam,
  awayTeam,
}) => {
  const header =
    seasonSegment === 'champseries'
      ? `${year} Championship Series Stats`
      : `${year} Stats`
  return (
    <>
      {homeTeam && awayTeam && (
        <>
          <TStatsHead>{header}</TStatsHead>
          {teamStatCompareList.map((item) => (
            <StatRow
              key={item}
              year={year}
              awayTeam={awayTeam}
              homeTeam={homeTeam}
              statName={item}
              seasonSegement={seasonSegment}
            />
          ))}
        </>
      )}
    </>
  )
}
